export var pointerEventAutoStyle = "\n  pointer-events: auto;\n";
export var pointerEventsNoneStyle = "\n  pointer-events: none;\n";